// ----------------------------------------------------------------------
// V2 Modern Card Styling

import { alpha } from '@mui/material/styles';

export default function Card(theme) {
  const isLight = theme.palette.mode === 'light';
  const primaryMain = '#7635dc';

  return {
    MuiCard: {
      styleOverrides: {
        root: {
          // V2: Purple-tinted soft shadow
          boxShadow: theme.customShadows.v2?.card || theme.customShadows.z16,
          borderRadius: theme.shape.borderRadiusMd,
          position: 'relative',
          zIndex: 0,
          // V2: Subtle border for depth
          border: `1px solid ${alpha(primaryMain, 0.08)}`,
          backgroundColor: isLight ? '#ffffff' : theme.palette.background.paper,
          // V2: Smooth transition for hover
          transition: 'box-shadow 0.25s ease-in-out, transform 0.25s ease-in-out',
          '&:hover': {
            boxShadow: theme.customShadows.v2?.hover || theme.customShadows.z20
          }
        }
      }
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: {
          variant: 'body2',
          marginTop: theme.spacing(0.5)
        }
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0)
        }
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3)
        }
      }
    }
  };
}
